// Components/Layout/TwoFAModal.tsx
import React, { useEffect, useState } from 'react';
import { Link, useStore } from 'react-admin';
import {
	Dialog,
	DialogTitle,
	DialogContent,
	TextField,
	DialogActions,
	Button,
} from '@mui/material';
import { getMe, validate2FACode } from '../../Services/users'; // Tes services
import { WebAuthnLogin } from '../TwoFa/Webauthn';

export const TwoFAModal = () => {
	const [isOpen, setOpen] = useStore('2fa.open', false);

	const [code, setCode] = useState('');
	const [method, setMethod] = useState<'app' | 'webauthn' | null>(null);
	const [error, setError] = useState('');

	useEffect(() => {
		if (isOpen) {
			getMe().then((user) => {
				setMethod(user.user.twoFAMethod);
			});
		}
	}, [isOpen]);

	const handleClose = () => {
		setOpen(false);
		setCode('');
		setError('');
	};

	const handleValidate = async () => {
		try {
			await validate2FACode(code); // Implémente cette fonction côté API

			runTwoFACallback();
			handleClose();
		} catch (err: any) {
			setError(err.message || 'Code invalide');
		}
	};

	return (
		<Dialog open={isOpen} onClose={handleClose} maxWidth="xs" fullWidth>
			<DialogTitle>Authentification 2FA requise</DialogTitle>
			<DialogContent>
				{method === 'app' ? (
					<TextField
						fullWidth
						label="Code temporaire"
						value={code}
						onChange={(e) => setCode(e.target.value)}
						error={!!error}
						helperText={error}
					/>
				) : method === 'webauthn' ? (
					<WebAuthnLogin />
				) : (
					<p>
						Vous devez définir une méthode d'authification à 2 facteurs{' '}
						<Link to="/2fa">ici</Link>
					</p>
				)}
			</DialogContent>
			<DialogActions>
				<Button onClick={handleClose}>Annuler</Button>
				<Button onClick={handleValidate} variant="contained">
					Valider
				</Button>
			</DialogActions>
		</Dialog>
	);
};

// src/Utils/TwoFA.ts
export let twoFACallback: null | (() => void) = null;

export function setTwoFACallback(cb: () => void) {
	twoFACallback = cb;
}

export function runTwoFACallback() {
	if (twoFACallback) {
		twoFACallback();
		twoFACallback = null; // reset après exécution
	} else {
		console.warn('No 2FA callback set');
	}
}
